<div class="login-container">
  <div *ngIf="isContentfulActive" [ngClass]="serviceName" class="login-info">
    <div>
      <app-cms-content
        [key]="'services.login-' + serviceName"
        [placeholder]="serviceName"
      ></app-cms-content>
      <div class="login-info__character" [ngClass]="serviceName"></div>
    </div>
    <div class="login-info__logo" [ngClass]="{ showActivation: stage === 'activate' }"></div>
  </div>
  <div class="login-panel forms-design-system buttons-design-system">
    <div>
      <ng-container [ngSwitch]="stage">
        <ng-container *ngSwitchCase="'login'">
          <div class="login-panel__logo--mobile"></div>
          <div class="login-panel__logo--image" [ngClass]="serviceName"></div>
          <div class="login-panel__title" [ngClass]="serviceName">
            {{ 'auth.title' | translate }}
          </div>
          <form (ngSubmit)="testServiceLogin()" #loginForm="ngForm">
            <div class="form__group">
              <label for="username">{{ 'auth.user' | translate }}</label>
              <input
                id="username"
                name="username"
                [(ngModel)]="credentials.username"
                type="email"
                placeholder="{{ 'auth.userPlaceholder' | translate }}"
                required
                [appGlfocus]="true"
                [ngClass]="{ failed: emailError }"
                (focusout)="testServiceLogin(false)"
              />
              <div *ngIf="emailError" class="form__error">
                <span class="glicon-alert-thin"></span>
                <span>
                  <app-dynamic-form-error [formError]="emailError"> </app-dynamic-form-error>
                </span>
              </div>
            </div>

            <div class="form__group">
              <label for="password">{{ 'nouns.password' | translate }}</label>
              <div class="form__field--icon">
                <input
                  id="password"
                  name="password"
                  [(ngModel)]="credentials.password"
                  [type]="passwordClear ? 'text' : 'password'"
                  placeholder="{{ 'auth.userPassword' | translate }}"
                  required
                  [ngClass]="{ failed: passwordError }"
                />
                <i
                  [ngClass]="{ 'glicon-view': passwordClear, 'glicon-no-view': !passwordClear }"
                  (click)="passwordClear = !passwordClear"
                ></i>
              </div>
              <div *ngIf="passwordError" class="form__error">
                <span class="glicon-alert-thin"></span>
                <span>
                  <app-dynamic-form-error [formError]="passwordError"> </app-dynamic-form-error>
                </span>
              </div>
            </div>

            <div class="login-panel__block">
              <!-- TODO <div class="checkbox small-check">
                <input type="checkbox" id="checkbox1" name="checkbox" value="">
                <label for="checkbox1">{{'auth.remember' | translate}}</label>
              </div> -->
              <a
                [routerLink]="['../forgot-password']"
                [queryParams]="{ username: credentials.username, sid: credentials.sid }"
                title=""
                class="login-panel__link"
                >{{ 'auth.forgotPasswordQuestion' | translate }}</a
              >
            </div>

            <button
              data-testid="submitLoginButton"
              type="submit"
              class="btn btn--primary"
              [disabled]="loginForm.invalid || loginForm.submitted"
            >
              {{ 'auth.title' | translate }}
            </button>
          </form>
          <div class="login-panel__help">
            <div *ngIf="serviceName === 'editor'" class="login-panel__help--register">
              <span>{{ 'auth.registerAccount' | translate }}</span>
              <a href="{{ 'auth.accountRegisterUrl' | translate }}" target="_blank">{{
                'auth.register' | translate
              }}</a>
            </div>
            <span>{{ 'auth.helpQuestion' | translate }}</span>
            <a href="{{ supportUrl }}" target="_blank" title="Support">
              {{ 'auth.contactLabel' | translate }}</a
            >
            <a (click)="changeUser()" class="login-panel__link visibility--hidden">
              {{ 'auth.changeUser' | translate }}
            </a>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'activate'">
          <ng-container
            *ngIf="
              ['roleplay', 'kepler', 'mars'].includes(serviceName) && emailError?.payload?.logo;
              else gamelearnLogo
            "
          >
            <div class="login-panel__logo--image activationAccount" [ngClass]="serviceName"></div>
            <div class="login-panel__logo--client">
              <img [src]="emailError.payload.logo" alt="" />
            </div>
          </ng-container>
          <ng-template #gamelearnLogo>
            <div class="login-panel__logo"></div>
          </ng-template>

          <div class="login-panel__title activate-account" [ngClass]="serviceName">
            {{ 'auth.activateYourAccount' | translate }}
          </div>
          <div class="login-panel__text bold activate-account">{{ credentials.username }}</div>
          <!-- <div class="login-panel__text">{{'auth.activateAccountQuestion' | translate}}</div> -->
          <form autocomplete="off" (ngSubmit)="activate()" #activationForm="ngForm">
            <div class="grid grid-center">
              <div class="s-12">
                <re-captcha
                  [siteKey]="captchaSiteKey"
                  [(ngModel)]="credentials.captchaValue"
                  id="captchaValue"
                  name="captchaValue"
                  required
                >
                </re-captcha>
              </div>
            </div>
            <div *ngIf="passwordError" class="form__group">
              <div class="form__error">
                <span class="glicon-alert-thin"></span>
                <span>
                  <app-dynamic-form-error [formError]="passwordError"> </app-dynamic-form-error>
                </span>
              </div>
            </div>
            <button
              type="submit"
              class="btn btn--primary activate-account"
              [disabled]="activationForm.invalid || activationForm.submitted"
            >
              {{ 'actions.activation' | translate }}
            </button>
          </form>

          <div class="login-panel__help no-margin">
            <a (click)="changeUser()" class="login-panel__link activate-account">{{
              'auth.changeUser' | translate
            }}</a>
            <span>{{ 'auth.helpQuestion' | translate }}</span>
            <a href="{{ supportUrl }}" target="_blank" title="Support">{{
              'auth.contactLabel' | translate
            }}</a>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
